import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap';
import ReferralPortfolio from './ReferralPortfolio';
import { Page } from '../../core';
import ReferredFriends from './ReferredFriends';
import ReferredActivities from './ReferredActivities';
import ReferCard from './ReferCard';
import PfCards from './PfCards';

function ReferralDashboardMain() {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    }, []);

    return (
        <Page className='refer-dashboard-main'> 
            <Col lg={12} xl={12} sm={12} xs={12} md={12}>
                <ReferralPortfolio />
                <ReferredFriends isMobile={isMobile} />
                <ReferredActivities isMobile={isMobile} />
            </Col>
            {/* <Col lg={4} xl={4} sm={12} xs={12} md={12}>
                <ReferCard/>
                <PfCards/>
            </Col> */}
        </Page>
    )
}

export default ReferralDashboardMain;